import { render } from "./GearButton.vue?vue&type=template&id=1e847b9a&scoped=true&ts=true"
import script from "./GearButton.vue?vue&type=script&lang=ts"
export * from "./GearButton.vue?vue&type=script&lang=ts"

import "./GearButton.vue?vue&type=style&index=0&id=1e847b9a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e847b9a"]])

export default __exports__